<odx-form-field i18n-label="@@newProject.projectForm.label.draegerContactPerson" label="Dräger-Kontaktperson">
  <input
    formControlName="draegerContactPerson"
    odxFormFieldControl
    type="email"
    i18n-placeholder="@@newProject.projectForm.placeholder.draegerContactPerson"
    placeholder="Dräger-Kontaktperson"
    [readonly]="isReadonly"
    [required]="required"
    data-testid="projectForm.draegerContactPerson"
  />
  <ng-template odxFormFieldError="email">
    <ng-container i18n="@@newProject.projectForm.errorMessage.invalidDraegerContactPersonEmail"
      >Bitte eine korrekte E-Mail eintragen</ng-container
    >
  </ng-template>
</odx-form-field>
